import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { formatNumber, formatPercentage } from 'utils/number';

interface Props {
  amount?: number;
  dataCy?: string;
  percentage?: number | null;
  family?: 'normal' | 'bold';
  isFillEmptyWithDash?: boolean;
  isColorless?: boolean;
  isSignless?: boolean;
  isOnlyPercentage?: boolean;
  isHidePositiveSign?: boolean;
  isMultiline?: boolean;
}

export default function PnLCurrency({
  amount = 0,
  dataCy = '',
  percentage = null,
  family = 'normal',
  isFillEmptyWithDash = false,
  isColorless = false,
  isSignless = false,
  isOnlyPercentage = false,
  isHidePositiveSign = false,
  isMultiline = false,
}: Readonly<Props>) {
  const isPositive = amount > 0;

  let sign = isPositive ? '+' : '-';

  if (isSignless || (isPositive && isHidePositiveSign)) {
    sign = '';
  }

  let textColor = isPositive ? color.primary : color.sunsetOrange;

  if (isColorless) {
    textColor = '';
  }

  if (amount === 0) {
    sign = '';
    textColor = '';
  }

  if (amount === 0 && isFillEmptyWithDash) {
    return (
      <Text data-cy={dataCy} family={family}>
        -
      </Text>
    );
  }

  if (isOnlyPercentage) {
    return (
      <Text data-cy={dataCy} color={textColor} family={family}>
        {sign}
        {formatPercentage(Math.abs(amount), false, '0,0.00', true)}
      </Text>
    );
  }

  const amountDisplayed = `${sign}Rp${formatNumber(Math.abs(amount))}`;
  let percentageDisplayed = '';
  if (percentage !== null) {
    const percentageSign = percentage !== 0 ? sign : '';
    percentageDisplayed = `(${percentageSign}${formatPercentage(
      Math.abs(percentage),
      false,
      '0,0.00',
      true,
    )})`;
  }

  const displayed = `${amountDisplayed} ${percentageDisplayed}`;

  return (
    <>
      {isMultiline && displayed.length > 22 ? (
        <div>
          <Text data-cy={dataCy} color={textColor} family={family}>
            {amountDisplayed}
          </Text>
          <Text data-cy={dataCy} color={textColor} family={family} align="end">
            {percentageDisplayed}
          </Text>
        </div>
      ) : (
        <Text data-cy={dataCy} color={textColor} family={family}>
          {displayed}
        </Text>
      )}
    </>
  );
}
